/**
 * Couleurs des graphiques du tableau de bord.
 *
 * ⚠️ Elles ne viennent PAS du branding de l'organisation. `--color-primary` et
 * `--color-accent` sont choisis par chaque client (white-label, #15) : un client
 * en vert ferait passer « en retard » pour « terminé ». Les états de complétion
 * sont une échelle de STATUT, à sens réservé, donc fixe pour tout le monde.
 *
 * Valeurs issues de la palette de statut documentée, et non choisies à l'œil.
 * Validation (protanopie/deutéranopie, Machado-Oliveira-Fernandes 1.0) :
 *   - séparation daltonisme  ΔE 11,3 sur la pire paire adjacente (seuil 8) ✓
 *   - plancher vision normale ΔE 24,4 (seuil 15) ✓
 *   - contraste sur fond clair : l'ambre est à 1,79, sous 3:1 **par construction**
 *     dans cette palette. La contrepartie exigée est « icône + libellé », jamais
 *     la couleur seule — d'où les icônes de la légende, qui ne sont pas
 *     décoratives : les retirer casse l'accessibilité du graphique.
 *
 * Les mêmes valeurs tiennent en thème sombre (toutes ≥ 3:1 sur la surface
 * sombre), ce qui évite un second jeu à maintenir.
 */
export const VIZ = {
  /** Terminé. */
  good: '#0ca30c',
  /** En cours. */
  warning: '#fab219',
  /** Échéance dépassée. */
  serious: '#ec835a',
  /** Échec, retard avéré. */
  critical: '#d03b3b',
  /** Jamais commencé, pas encore ouvert : absence, pas état. */
  muted: '#898781',
} as const

/**
 * Piste d'un meter : un pas plus clair de la MÊME rampe que le remplissage, pas
 * un gris neutre — c'est ce qui fait lire l'état sur toute la barre plutôt que
 * sur son seul segment rempli.
 */
export function meterTrack(fill: string): string {
  return `color-mix(in oklch, ${fill} 16%, transparent)`
}

/**
 * Arrondit un pourcentage en gardant 0 et 100 exacts.
 *
 * `Math.round` seul affiche « 100 % » à 99,6 % : sur un tableau de bord de
 * complétion, annoncer une promo finie alors qu'il reste quelqu'un est
 * précisément l'erreur à ne pas commettre.
 */
export function percent(value: number, total: number): number {
  if (total <= 0) return 0
  const raw = (value / total) * 100
  if (raw > 0 && raw < 1) return 1
  if (raw > 99 && raw < 100) return 99
  return Math.round(raw)
}
